module.exports = __webpack_public_path__ + "assets/skype.3e5908ca.svg";